<template>
  <div class="wrap-container">
    <div class="assets"></div>
    <div class="wrap-content">
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrap-container {
  background: var(--primary);
  min-height: 100vh;
  width: 100%;
}

.assets {
  /* width: 100%; */
  height: 95vh;
  border-bottom-right-radius: 100%;
  background: #fff;
}
</style>
